import React from "react";
import Header from "../components/common/Header";
import MainComponent from "../components/LandingPage/MainComponent";
import Footer from "../components/common/Footer"

function HomePage() {
  return (
    <div>
      <Header />
      <MainComponent />
      <Footer/>
    </div>
  );
}

export default HomePage;
